/*
 * Copyright 2021 by Bob Kerns. Licensed under MIT license.
 *
 * Github: https://github.com/BobKerns/genutils
 */
/**
 * Utilities for implementing or using generators.
 * @module util
 */
/**
 * Delay for the specified number of milliseconds.
 *
 * @param ms
 * @param value
 * @returns
 */
export const delay = (ms, value) => new Promise(acc => setTimeout(() => acc(value), ms));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7O0dBSUc7QUFDSDs7O0dBR0c7QUFFSDs7Ozs7O0dBTUc7QUFDSCxNQUFNLENBQUMsTUFBTSxLQUFLLEdBQUcsQ0FBQyxFQUFVLEVBQUUsS0FBVyxFQUFFLEVBQUUsQ0FDN0MsSUFBSSxPQUFPLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxVQUFVLENBQUMsR0FBRyxFQUFFLENBQUMsR0FBRyxDQUFDLEtBQUssQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyIvKlxuICogQ29weXJpZ2h0IDIwMjEgYnkgQm9iIEtlcm5zLiBMaWNlbnNlZCB1bmRlciBNSVQgbGljZW5zZS5cbiAqXG4gKiBHaXRodWI6IGh0dHBzOi8vZ2l0aHViLmNvbS9Cb2JLZXJucy9nZW51dGlsc1xuICovXG4vKipcbiAqIFV0aWxpdGllcyBmb3IgaW1wbGVtZW50aW5nIG9yIHVzaW5nIGdlbmVyYXRvcnMuXG4gKiBAbW9kdWxlIHV0aWxcbiAqL1xuXG4vKipcbiAqIERlbGF5IGZvciB0aGUgc3BlY2lmaWVkIG51bWJlciBvZiBtaWxsaXNlY29uZHMuXG4gKlxuICogQHBhcmFtIG1zXG4gKiBAcGFyYW0gdmFsdWVcbiAqIEByZXR1cm5zXG4gKi9cbmV4cG9ydCBjb25zdCBkZWxheSA9IChtczogbnVtYmVyLCB2YWx1ZT86IGFueSkgPT5cbiAgICBuZXcgUHJvbWlzZShhY2MgPT4gc2V0VGltZW91dCgoKSA9PiBhY2ModmFsdWUpLCBtcykpOyJdfQ==